import React from 'react';
import { WebsiteDesignProps } from './types';
import { Plane, Cloud, Map, User } from 'lucide-react';
import { Button } from "@/components/ui/button";

const AviationAcademy: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Horizon Flight School";

    return (
        <div className="bg-sky-50 min-h-screen font-sans text-slate-700">
            <nav className="bg-white px-8 py-4 flex justify-between items-center shadow-sm sticky top-0 z-50">
                <div className="flex items-center gap-2 text-[#0284c7] font-bold text-xl uppercase italic tracking-wider">
                    <Plane className="transform -rotate-45" fill="currentColor" /> {schoolName}
                </div>
                <div className="hidden md:flex gap-8 text-xs font-bold uppercase tracking-widest text-slate-400">
                    <a href="#" className="hover:text-[#0284c7]">Fleet</a>
                    <a href="#" className="hover:text-[#0284c7]">Instructors</a>
                    <a href="#" className="hover:text-[#0284c7]">Simulation</a>
                    <a href="#" className="hover:text-[#0284c7]">Careers</a>
                </div>
                <Button className="bg-[#0284c7] hover:bg-[#0369a1] text-white uppercase text-xs font-bold tracking-widest rounded px-6">
                    Book Flight
                </Button>
            </nav>

            <header className="relative h-[600px] overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-b from-sky-400 to-sky-100"></div>
                <div className="absolute inset-0">
                    {/* Clouds */}
                    <Cloud className="text-white opacity-40 absolute top-20 left-20 w-32 h-32" fill="currentColor" />
                    <Cloud className="text-white opacity-30 absolute top-40 right-40 w-48 h-48" fill="currentColor" />
                    <Cloud className="text-white opacity-50 absolute bottom-20 left-1/3 w-64 h-64" fill="currentColor" />
                </div>
                
                <div className="container mx-auto px-8 relative z-10 h-full flex items-center">
                    <div className="max-w-xl">
                        <div className="inline-block px-3 py-1 bg-white/20 backdrop-blur text-white border border-white/40 rounded text-xs font-bold uppercase tracking-widest mb-6">
                            FAA Part 141 Approved
                        </div>
                        <h1 className="text-6xl font-black text-white mb-6 uppercase italic leading-none drop-shadow-lg">
                            Take Your <br/> Dreams <br/> <span className="text-[#e0f2fe]">Higher.</span>
                        </h1>
                        <p className="text-xl text-sky-900 font-medium mb-8 max-w-sm">
                            Professional pilot training for the airlines of tomorrow. From zero to commercial license in 12 months.
                        </p>
                        <Button className="h-14 px-8 bg-white text-[#0284c7] hover:bg-sky-50 font-black uppercase italic tracking-wider text-sm rounded shadow-xl">
                            Start Enrollment
                        </Button>
                    </div>
                </div>
            </header>

            <section className="py-20 bg-white">
                <div className="container mx-auto px-8 grid grid-cols-1 md:grid-cols-3 gap-8 -mt-32 relative z-20">
                    {[
                        { icon: Plane, title: "Private Pilot", desc: "Your first step into the skies. Learn the fundamentals of flight." },
                        { icon: Map, title: "Instrument Rating", desc: "Master navigation and flying in all weather conditions." },
                        { icon: User, title: "Commercial", desc: "Turn your passion into a career. Precision and professionalism." },
                    ].map((item, i) => (
                        <div key={i} className="bg-white p-8 rounded-lg shadow-xl border-b-4 border-[#0284c7] hover:-translate-y-2 transition-transform">
                            <div className="w-12 h-12 bg-sky-100 rounded flex items-center justify-center text-[#0284c7] mb-6">
                                <item.icon />
                            </div>
                            <h3 className="text-xl font-bold uppercase italic text-slate-800 mb-3">{item.title}</h3>
                            <p className="text-slate-500 text-sm leading-relaxed">{item.desc}</p>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default AviationAcademy;
